import React, { useEffect, useState } from "react";
import "./Dashboard.scss";
import { Button, Flex, Spin, Tabs, Tooltip } from "antd";
import edit from "../../../Assets/svg/table-action-edit.svg";
import preview from "../../../Assets/svg/table-action-preview.svg";
import icon1 from "../../../Assets/svg/projectDashboardIcon1.svg";
import icon2 from "../../../Assets/svg/projectDashboardIcon2.svg";
import icon3 from "../../../Assets/svg/projectDashboardIcon3.svg";
import action1 from "../../../Assets/Images/quickAction1.png";
import action2 from "../../../Assets/Images/quickAction2.png";
import action3 from "../../../Assets/Images/quickAction3.png";
import action4 from "../../../Assets/Images/quickAction4.png";
import TpmSummary from "./TPMsummary/TpmSummary";
import IpSummary from "./IPsummary/IpSummary";
import SiteVisitSummary from "./SiteVisitSummary/SiteVisitSummary";
import EditProject from "../projects/EditProject";
import PreviewProject from "../projects/PreviewProject";
import { httpService } from "../../../services/httpService.service";
import AddSiteVisitCardModal from "../../pages/planning/VisitBoard/Modals/AddSiteVisitCardModal";
import AddNewTaskModal from "../planning/TasksAssignments/Modals/AddNewTaskModal";
import AddIpPlan from "../planning/modals/AddModal";
import MessagePopUp from "../../components/Messages/MessagePopUp";
import AddRedFlagCardModal from "../Flags/Modals/AddRedFlagCardModal";
import { RolesEnum } from "../../../services/rolesEnum";
import { isAuthorized } from "../../../services/authService";
import { formatDateAndTime } from "../../../services/helpFunctions/formatDateAndTime";
import VisitDataSummary from "./VisitDataSummary/VisitDataSummary";

const { TabPane } = Tabs;

function Dashboard() {
  const projectID = localStorage.getItem("currentProjectID");
  const isGuestShare = process.env.REACT_APP_API_IS_GUEST;
  const [activeComponent, setActiveComponent] = useState("SiteVisitSummary");
  const [showEditProjectModal, setShowEditProjectModal] = useState(false);
  const [showPreviewProjectModal, setShowPreviewProjectModal] = useState(false);
  const [projectData, setProjectData] = useState(null);
  const [dashboardData, setDashboardData] = useState(null);
  const [reloadKey, setReloadKey] = useState(0); // State variable to trigger re-render
  const [isModalVisibleSiteVisit, setIsModalVisibleSiteVisit] = useState(false);
  const [isModalVisibleAddTask, setIsModalVisibleAddTask] = useState(false);
  const [isModalVisibleAddFlag, setIsModalVisibleAddFlag] = useState(false);
  const [isModalVisibleAddModal, setIsModalVisibleAddModal] = useState(false);
  const [loadingProject, setLoadingProject] = useState(false);
  const [loadingDashboard, setLoadingDashboard] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [message, setMessage] = useState({
    trigger: false,
    type: "",
    icon: "",
    title: "",
    text: "",
  });

  const showModalSiteVist = () => {
    setIsModalVisibleSiteVisit(true);
  };

  const showModalAddFlag = () => {
    setIsModalVisibleAddFlag(true);
  };
  const showModalEditModal = () => {
    setIsModalVisibleAddModal(true);
  };

  const showModalAddTask = () => {
    setIsModalVisibleAddTask(true);
  };

  const handleOk = () => {
    setIsModalVisibleSiteVisit(false);
  };

  const handleCancel = () => {
    setIsModalVisibleSiteVisit(false);
    setIsModalVisibleAddTask(false);
    setIsModalVisibleAddFlag(false);
    setIsModalVisibleAddModal(false);
  };

  const openActiveComponent = (collector) => {
    setActiveComponent(collector);
  };

  const handleAddedIpPlan = () => {
    //reload the dashboard
  };
  const fetchProjectData = async () => {
    if (projectID) {
      setLoadingProject(true);
      try {
        await new Promise((resolve, reject) => {
          httpService.get(
            `/api/Projects?id=${projectID}`,
            (response) => {
              setProjectData(response.data);
              resolve();
            },
            (error) => {
              console.error("Error fetching project data:", error);
              reject(error);
            }
          );
        });
      } catch (error) {
        // error already logged
      } finally {
        setLoadingProject(false);
      }
    }
  };

  const fetchDashboardData = async () => {
    if (projectID) {
      setLoadingDashboard(true);
      httpService.get(
        `/api/Projects/getProjectInfo?id=${projectID}`,
        (response) => {
          setDashboardData(response.data);
          setLoadingDashboard(false);
        },
        (error) => {
          console.error("Error fetching project info:", error);
          setLoadingDashboard(false);
        }
      );
    }
  };


  const handleSubmit = () => {
    fetchProjectData();
  };

  useEffect(() => {
    fetchDashboardData();
  }, [reloadKey]);

  const truncatedDescription = isExpanded
    ? dashboardData?.description
    : `${dashboardData?.description?.substring(0, 80)}...`;

  const toggleDescription = () => {
    setIsExpanded(!isExpanded);
  };

  if (loadingDashboard) {
    return (
      <div style={{ height: "calc(100vh - 130px)", width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Spin size="small" />
      </div>
    );
  }

  return (
    <div>
      <MessagePopUp
        trigger={message.trigger}
        type={message.type}
        icon={message.icon}
        messageTitle={message.title}
        messageText={message.text}
      />
      {/* ...existing code for dashboard content... */}
      <div className="projectName">
        <div className="projectContent">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Tooltip
              className="text-truncate"
              title={`Project Round Name: ${dashboardData?.projectName || "-"}`}
            >
              <h2 className="projectNameText">
                {(dashboardData?.projectName || "")} - Dashboard
              </h2>
            </Tooltip>
            <div className="d-flex justify-content-between align-items-center">
              <Button
                className="projectDashboardButton"
                onClick={async () => {
                  setShowPreviewProjectModal(true);
                  if (!projectData) {
                    await fetchProjectData();
                  }
                }}
              >
                <img src={preview}></img>
              </Button>
              {isAuthorized([
                RolesEnum.ProjectManager,
                RolesEnum.SystemAdmin,
              ]) && (
                <Button
                  className="projectDashboardButton"
                  onClick={() => {
                    setShowEditProjectModal(true);
                  }}
                >
                  <img src={edit}></img>
                </Button>
              )}
            </div>
          </div>
          {dashboardData?.description && (
            <Tooltip title={`Project Description`}>
              <p className="projectNameDescription">
                {truncatedDescription}
                {dashboardData?.description?.length > 80 && (
                  <span
                    onClick={toggleDescription}
                    style={{
                      paddingLeft: "5px",
                      color: "#aa1a5f",
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: 500,
                      cursor: "pointer",
                    }}
                  >
                    {isExpanded ? "See Less" : "See More"}
                  </span>
                )}
              </p>
            </Tooltip>
          )}
        </div>
        <div className="projectTags">
          <div className="projectTagDesign">
            <Tooltip
              title={`Clients: ${dashboardData?.clients
                ? dashboardData.clients.map((client) => client.name).join(", ")
                : "-"}`}
            >
              <img
                src={icon1}
                alt={`userIcon`}
                style={{ marginRight: "8px" }}
              />
              <span
                className="text-truncate"
                style={{
                  display: "inline-block",
                  maxWidth: "150px",
                  verticalAlign: "middle",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {dashboardData?.clients
                  ? dashboardData.clients.map((client, index) => (
                      <React.Fragment key={client.id}>
                        {client.name}
                        {index !== dashboardData.clients.length - 1 && ", "}
                      </React.Fragment>
                    ))
                  : "-"}
              </span>
            </Tooltip>
          </div>
          <div className="projectTagDesign">
            <Tooltip
              title={`Project Round Name: ${dashboardData?.projectName || "-"}`}
            >
              <img
                src={icon2}
                alt="Icon 2"
                style={{ marginRight: "8px" }}
              />
              <span
                className="text-truncate"
                style={{
                  display: "inline-block",
                  maxWidth: "150px",
                  verticalAlign: "middle",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {dashboardData?.projectName || "-"}
              </span>
            </Tooltip>
          </div>
          <div className="projectTagDesign">
            <Tooltip
              title={`Updated Date: ${
                dashboardData?.updatedDate
                  ? formatDateAndTime(dashboardData.updatedDate)
                  : dashboardData?.createdDate
                  ? formatDateAndTime(dashboardData.createdDate)
                  : "-"
              }`}
            >
              <img
                src={icon3}
                alt="Icon 3"
                style={{ marginRight: "8px" }}
              />
              <span
                className="text-truncate"
                style={{
                  display: "inline-block",
                  maxWidth: "150px",
                  verticalAlign: "middle",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {dashboardData?.updatedDate
                  ? formatDateAndTime(dashboardData.updatedDate)
                  : dashboardData?.createdDate
                  ? formatDateAndTime(dashboardData.createdDate)
                  : "-"}
              </span>
            </Tooltip>
          </div>
        </div>
      </div>
      <div style={{ padding: "24px", background: "#F6F6F6" }}>
        {!isGuestShare && (
          <div className="actionsDiv">
            <h2>Quick Actions</h2>
            <div className="quickActions">
              {isAuthorized([
                RolesEnum.ProjectManager,
                RolesEnum.SystemAdmin,
              ]) && (
                <Button
                  className="quickActionsButton"
                  onClick={showModalEditModal}
                >
                  <img src={action2}></img> Create IP Planning Card
                </Button>
              )}
              {isAuthorized([
                RolesEnum.ProjectManager,
                RolesEnum.SystemAdmin,
              ]) && (
                <Button
                  className="quickActionsButton"
                  onClick={showModalSiteVist}
                >
                  <img src={action4}></img> Create Site Visit Card
                </Button>
              )}
              <Button
                className="quickActionsButton"
                onClick={showModalAddTask}
              >
                <img src={action3}></img> Create Task Card
              </Button>

              <Button
                className="quickActionsButton"
                onClick={showModalAddFlag}
              >
                <img src={action1}></img>Create Red Flag Card
              </Button>

              <AddSiteVisitCardModal
                visible={isModalVisibleSiteVisit}
                onOk={handleOk}
                onCancel={handleCancel}
                setMessage={setMessage}
              />

              <AddNewTaskModal
                setMessage={setMessage}
                visible={isModalVisibleAddTask}
                setIsModalVisible={handleCancel}
                updateData={() => {}}
              />
              <AddRedFlagCardModal
                visible={isModalVisibleAddFlag}
                onClose={handleCancel}
                setMessage={setMessage}
                fetchRedFlags={handleCancel}
                fetchDraftData={() => {}}
                setFetchDraftData={() => {}}
              />
              <AddIpPlan
                visible={isModalVisibleAddModal}
                onClose={() => setIsModalVisibleAddModal(false)}
                setMessage={setMessage}
                setFetchDraftData={() => {}}
                onAdd={handleAddedIpPlan}
              />
            </div>
          </div>
        )}
      </div>
      <div className="planning-page">
        <Tabs
          type="card"
          className="card-tabs"
          // activeKey={getDefaultActiveKey()}
          // onChange={handleTabChange}
          destroyInactiveTabPane={true}
          defaultActiveKey={
            isGuestShare ? "tpm-summary" : "site-visit-summary"
          }
        >
          {!isGuestShare && (
            <TabPane tab="Site Visit Summary" key="site-visit-summary">
              <div className="insideTab">
                <SiteVisitSummary />
              </div>
            </TabPane>
          )}

          <TabPane tab="TPM Summary" key="tpm-summary">
            <div className="insideTab">
              {/* <VisitsBoard /> */}
              <TpmSummary />
            </div>
          </TabPane>

          {!isGuestShare && (
            <TabPane tab="IP Summary" key="ip-summary">
              <div className="insideTab">
                <IpSummary />
              </div>
            </TabPane>
          )}

          <TabPane tab="Visit Data Summary" key="visit-data-summary">
            <VisitDataSummary
              countryOfProjectId={projectData?.projectDetails?.country?.id}
              fetchProjectData={fetchProjectData}
              projectData={projectData}
            />
          </TabPane>
        </Tabs>
      </div>
      <EditProject
        visible={showEditProjectModal}
        onClose={() => setShowEditProjectModal(false)}
        projectId={projectID}
        onSubmit={handleSubmit}
        setMessage={setMessage}
      />
      <PreviewProject
        visible={showPreviewProjectModal}
        onClose={() => setShowPreviewProjectModal(false)}
        project={projectData}
        loading={loadingProject || (!projectData && showPreviewProjectModal)}
      />
    </div>
  
  );
}

export default Dashboard;
